// extracted by mini-css-extract-plugin
export default {"root":"IconStar_root__soorE"};